var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "explore" }, [
    _c("div", { staticClass: "explore-title" }, [_c("CustomBreadcrumb")], 1),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "explore-tabs" },
      [
        _c(
          "el-tabs",
          {
            on: { "tab-click": _vm.handleClick },
            model: {
              value: _vm.activeName,
              callback: function($$v) {
                _vm.activeName = $$v
              },
              expression: "activeName"
            }
          },
          [
            _c(
              "el-tab-pane",
              {
                attrs: {
                  label: "AI Recommendations",
                  name: "aiRecommendations"
                }
              },
              [
                _vm.activeName === "aiRecommendations"
                  ? _c("AiRecommendations")
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-tab-pane",
              { attrs: { label: "Explore", name: "explore" } },
              [
                _vm.activeName === "explore"
                  ? _c("Explore", {
                      attrs: {
                        "user-id": _vm.userId,
                        "store-id": _vm.storeId,
                        "store-name": _vm.storeName,
                        "store-address": _vm.storeAddress,
                        "is-show-report": _vm.isShowReport
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-tab-pane",
              { attrs: { label: "Widget", name: "widget" } },
              [_vm.activeName === "widget" ? _c("Widget") : _vm._e()],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-03bf757f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03bf757f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/vilocal/explore-parent.vue
// module id = LBYu
// module chunks = 2